document.addEventListener('DOMContentLoaded', function () {
  let intervalId;

  function attachSizeButtonListeners() {
    const sizeButtons = document.querySelectorAll('.product-card__size-button');
    if (!sizeButtons.length) return false;

    sizeButtons.forEach(button => {
      if (button.dataset.listenerAdded) return; // Prevent double attachment
      button.dataset.listenerAdded = true;

      button.addEventListener('click', function () {
        const variantId = this.dataset.variantId;
        if (!variantId) return;

        this.classList.add('active');
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(response => {
            if (!response.ok) throw new Error('Failed to add to cart');
            return response.json();
          })
          .then(data => {
            // console.log('✅ Added to cart:', data);

            // Trigger cart events
            document.dispatchEvent(new CustomEvent('cart:change', {
              detail: { baseEvent: 'variant:add', cart: { sections: {} }, onSuccessDo: 'force_open_drawer' }
            }));
            document.dispatchEvent(new Event('cart:refresh'));
          })
          .catch(error => console.error('❌ Error adding to cart:', error))
          .finally(() => {
            this.classList.remove('active');
            this.disabled = false;
          });
      });
    });

    return true; // Successfully attached
  }

  // Start interval to check if size buttons exist
  intervalId = setInterval(() => {
    const attached = attachSizeButtonListeners();
    if (attached) clearInterval(intervalId); // Stop once buttons are found & listeners attached
  }, 300);
  

  // Shopify cart events — re-run initSlider or your JS when drawer updates
  ['cart:updated', 'cart:drawer:open', 'cart:drawer:updated'].forEach(evt => {
    document.addEventListener(evt, () => {
      // initSlider();
      // Optional: reattach listeners if new product cards are added dynamically
      attachSizeButtonListeners();
    });
  });

  // Fallback — observe cart drawer DOM for dynamic changes
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      // initSlider();
      attachSizeButtonListeners();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  const cartDot = document.querySelector('cart-dot');
  if (!cartDot) return;

  // Function to update cart count
  function updateCartDot() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const count = cart.item_count;
        cartDot.textContent = count > 0 ? count : '0';
        cartDot.classList.toggle('is-visible', count > 0);
      });
  }

  // When product is added to cart (Shopify AJAX)
  document.addEventListener('cart:change', updateCartDot);

  // Also update after page load or when user returns
  window.addEventListener('pageshow', updateCartDot);

  // OPTIONAL: update immediately after add-to-cart fetch
  document.body.addEventListener('click', (e) => {
    if (e.target.closest('form[action^="/cart/add"]')) {
      setTimeout(updateCartDot, 800); // small delay for fetch to complete
    }
  });

  // Initial load
  updateCartDot();
});


$(document).ready(function () {
  function initFooterToggle() {
    // Mobile
    if ($(window).width() <= 768) {

      // Hide all lists initially
      $(".footer .footer__block--links ul").hide();

      // Remove old bindings and rebind
      $(".footer .footer-item__title").off("click").on("click", function () {

        // Correct selector: find UL inside the same block
        $(this)
          .closest(".footer__block")
          .find(".footer__block--links ul")
          .slideToggle(300);

        $(this).toggleClass("is-active");
      });

    } else {
      // Desktop
      $(".footer .footer__block--links ul").show();     // always shown
      $(".footer .footer-item__title").off("click");     // no toggle
      $(".footer-item__title").removeClass("is-active"); // reset icons
    }
  }

  // Run on load
  initFooterToggle();

  // Re-run on resize
  $(window).on("resize", function () {
    initFooterToggle();
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Function to attach click listeners to size variants
  var attachSizeListeners = function() {
    const sizeVariants = document.querySelectorAll('.size-variant');

    sizeVariants.forEach(variant => {
      if (!variant.dataset.listenerAdded) {
        variant.addEventListener('click', function () {
          // Remove active class from all size variants
          sizeVariants.forEach(v => v.classList.remove('active'));

          // Add active class to clicked variant
          this.classList.add('active');
        });

        variant.dataset.listenerAdded = 'true'; // mark listener as added
      }
    });
  };

  // Function to initialize everything
  var initSizeVariants = function() {
    // Wait until size variants exist
    var checkExist = setInterval(function () {
      if (document.querySelectorAll('.size-variant').length > 0) {
        attachSizeListeners();
        clearInterval(checkExist);
      }
    }, 200);
  };

  // Initial attach
  initSizeVariants();

  // Shopify cart drawer events — re-attach on updates
  document.addEventListener('cart:updated', attachSizeListeners);
  document.addEventListener('cart:drawer:open', attachSizeListeners);
  document.addEventListener('cart:drawer:updated', attachSizeListeners);

  // Fallback — observe DOM for cart drawer changes
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      attachSizeListeners();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
});





document.addEventListener('DOMContentLoaded', function () {
  function initSlider() {
    const sliders = document.querySelectorAll('#complementary-slider');

  sliders.forEach((slider) => {
    if (slider.classList.contains('splide-initialized')) return;

    const splide = new Splide(slider, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      arrows: false,
      pagination: false,
      breakpoints: { 1024: { perPage: 2 } },
    }).mount();

    // Create custom arrows container
    const arrowsWrapper = document.createElement('div');
    arrowsWrapper.classList.add('custom-arrows');

    // Create Prev button
    const prevBtn = document.createElement('button');
    prevBtn.classList.add('custom-prev');
    prevBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
        <path d="M7.91872 14.5664L0.847656 7.49536L7.91872 0.424294" stroke="black" stroke-width="1.2"/>
      </svg>
    `;

    // Create Next button (mirrored arrow)
    const nextBtn = document.createElement('button');
    nextBtn.classList.add('custom-next');
    nextBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none" style="transform: rotate(180deg);">
        <path d="M7.91872 14.5664L0.847656 7.49536L7.91872 0.424294" stroke="black" stroke-width="1.2"/>
      </svg>
    `;

    // Append buttons to wrapper
    arrowsWrapper.appendChild(prevBtn);
    arrowsWrapper.appendChild(nextBtn);

    // Insert arrows after slider
    slider.parentNode.insertBefore(arrowsWrapper, slider.nextSibling);

    // Add click events
    prevBtn.addEventListener('click', () => splide.go('<'));
    nextBtn.addEventListener('click', () => splide.go('>'));
  

    // Store Splide instance on element for reference
    slider._splide = splide;

    // Handle size buttons inside THIS slider only
    slider.addEventListener('pointerdown', (e) => {
      const btn = e.target.closest('.product-card__size-button');
      if (!btn) return;

      splide.Components.Drag.disable(true); // disable drag
      e.stopPropagation(); // stop drag event from bubbling
    }, { passive: true });

    const reEnable = () => {
      splide.Components.Drag.disable(false); // re-enable drag
    };
    slider.addEventListener('pointerup', reEnable);
    slider.addEventListener('pointercancel', reEnable);
    slider.addEventListener('pointerleave', reEnable);

    // Prevent click events from triggering slider drag
    slider.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-card__size-button');
      if (btn) e.stopPropagation();
    });

    $('.product-card__size-button').bind('swipeLeft swipeRight', function(event) {
        event.stopPropagation();
    });

    slider.classList.add('splide-initialized');

  });
  }

  // Initial check
  const checkExist = setInterval(function () {
    if (document.querySelector('#complementary-slider')) {
      initSlider();
      clearInterval(checkExist);
    }
  }, 300);

  // Detect cart drawer updates (Shopify uses custom events)
  document.addEventListener('cart:updated', initSlider);
  document.addEventListener('cart:drawer:open', initSlider);
  document.addEventListener('cart:drawer:updated', initSlider);

  // Fallback — observe DOM for cart drawer content changes
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      initSlider();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
  
});




document.addEventListener('DOMContentLoaded', function () {
  var checkSlider = setInterval(function () {
    var sliderEl = document.querySelector('#product-recommendations-slider');
    if (sliderEl && typeof Splide !== 'undefined') {
      clearInterval(checkSlider);

      var splide = new Splide('#product-recommendations-slider', {
        type: 'slide',
        perPage: 4,
        arrows: false,
        pagination: false,
        breakpoints: {
          1024: { perPage: 3 },
          768: { perPage: 2 },
        },
      });

      splide.mount();

      // Store Splide instance on element for reference
      sliderEl._splide = splide;

      // Handle size buttons inside THIS slider only
      sliderEl.addEventListener(
        'pointerdown',
        (e) => {
          const btn = e.target.closest('.product-card__size-button');
          if (!btn) return;

          // Disable drag when pressing size button
          splide.Components.Drag.disable(true);
          e.stopPropagation();
        },
        { passive: true }
      );

      const reEnable = () => {
        splide.Components.Drag.disable(false); // Re-enable drag
      };

      // Restore drag when pointer is released or leaves
      sliderEl.addEventListener('pointerup', reEnable);
      sliderEl.addEventListener('pointercancel', reEnable);
      sliderEl.addEventListener('pointerleave', reEnable);

      // Prevent click on size buttons from triggering drag
      sliderEl.addEventListener('click', (e) => {
        const btn = e.target.closest('.product-card__size-button');
        if (btn) e.stopPropagation();
      });
    }
  }, 300); // checks every 300ms
});




document.addEventListener('DOMContentLoaded', function () {
  var checkExist = setInterval(function () {
    var slider = document.querySelector('.similar-style-slider');
    if (slider && typeof Splide !== 'undefined') {
      clearInterval(checkExist);

      // Initialize Splide
      var splide = new Splide(slider, {
        type: 'slide',
        perPage: 4,
        pagination: false,
        arrows: false,
        breakpoints: {
          1024: { perPage: 3 },
          768: { perPage: 2 },
        },
      }).mount();

      // Store Splide instance for reference
      slider._splide = splide;

      // Handle size buttons inside THIS slider only
      slider.addEventListener(
        'pointerdown',
        (e) => {
          const btn = e.target.closest('.product-card__size-button');
          if (!btn) return;

          // Disable drag
          splide.Components.Drag.disable(true);
          e.stopPropagation();
        },
        { passive: true }
      );

      const reEnable = () => {
        splide.Components.Drag.disable(false); // Re-enable drag
      };

      // Restore drag when pointer is released or leaves
      slider.addEventListener('pointerup', reEnable);
      slider.addEventListener('pointercancel', reEnable);
      slider.addEventListener('pointerleave', reEnable);

      // Prevent click events on size buttons from triggering drag
      slider.addEventListener('click', (e) => {
        const btn = e.target.closest('.product-card__size-button');
        if (btn) e.stopPropagation();
      });
    }
  }, 300);
});


document.addEventListener('DOMContentLoaded', function () {
  var checkExist = setInterval(function () {
    var triggerBox = document.querySelector('.my-size-box');
    var targetButton = document.querySelector('.ks-chart-container button.sizing-chart-modal-button');

    if (triggerBox && targetButton) {
      clearInterval(checkExist);

      triggerBox.addEventListener('click', function () {
        targetButton.click();
      });
    }
  }, 200);

});

document.addEventListener('DOMContentLoaded', function () {
  var checkExist = setInterval(function () {
    var trigger = document.querySelector('.show-size-guide');
    var targetButton = document.querySelector('.ks-chart-container button.sizing-chart-modal-button');

    if (trigger && targetButton) {
      clearInterval(checkExist); // stop checking

      // Add click event to trigger
      trigger.addEventListener('click', function () {
        targetButton.click();
      });
    }
  }, 100); // check every 100ms
});



document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.querySelector('.header .header__primary-nav button');
  const sidebar = document.querySelector('.custom-sidebar');
  const body = document.body;

  if (!toggleBtn || !sidebar) return; // safety check

  toggleBtn.addEventListener('click', () => {
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

    // Toggle aria-expanded
    toggleBtn.setAttribute('aria-expanded', !isExpanded);

    // Toggle sidebar active class
    sidebar.classList.toggle('active', !isExpanded);

    // Toggle body hidden class
    body.classList.toggle('overflow-hidden', !isExpanded);
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const mediaItems = document.querySelectorAll(
      ".template-product .product-gallery .product-gallery__media"
    );

    // if elements found
    if (mediaItems.length > 0) {
      clearInterval(interval); // stop checking

      mediaItems.forEach((item) => {
        item.addEventListener("click", function () {
          const zoomBtn = document.querySelector(".product-gallery__zoom-button");
          if (zoomBtn) zoomBtn.click();
        });
      });
    }
  }, 300); // check every 300ms
});



const observer = new MutationObserver(() => {
  const sizeBtns = document.querySelectorAll(".product-card__size-button");

  sizeBtns.forEach(btn => {
    if (btn.dataset.listenerAdded) return; // prevent duplicate listeners
    btn.dataset.listenerAdded = "true";

    btn.addEventListener("click", async function () {
      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (res.ok) {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          console.log("Added:", variantId);
        }

        document.dispatchEvent(new CustomEvent('cart:change', {
              detail: { baseEvent: 'variant:add', cart: { sections: {} }, onSuccessDo: 'force_open_drawer' }
            }));
            document.dispatchEvent(new Event('cart:refresh'));

      } catch (err) {
        console.error(err);
      }
    });
  });
});

// Watch body for new elements (like recommendations)
observer.observe(document.body, {
  childList: true,
  subtree: true
});



let variantChecker = setInterval(() => {
  const variants = document.querySelectorAll("#product-recommendations-slider .size-variant");

  if (variants.length > 0) {
    variants.forEach((item) => {
      item.addEventListener("click", () => {
        variants.forEach(v => v.classList.remove("active"));
        item.classList.add("active");
      });
    });

    clearInterval(variantChecker);
  }
}, 200);



document.addEventListener("DOMContentLoaded", () => {

  const handler = (e) => {
    const btn = e.target.closest(".custom-sortby-list .popover__value-option");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productList = document.querySelector("product-list");
    const sortValue = btn.getAttribute("value");
    if (!productList || !sortValue) return;

    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sortValue);
    history.pushState({}, "", url.toString());

    productList.classList.add("loading");

    fetch(url.toString())
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newProductList = doc.querySelector("product-list");

        if (newProductList) {
          productList.innerHTML = newProductList.innerHTML;
        }

        productList.classList.remove("loading");

        const allSortButtons = document.querySelectorAll(".custom-sortby-list .popover__value-option");
        allSortButtons.forEach(b => b.removeAttribute("aria-selected"));

        allSortButtons.forEach(b => {
          if(b.getAttribute("value") === sortValue) {
            b.setAttribute("aria-selected", "true");
          }
        });
      })
      .catch(err => console.error("AJAX sort error:", err));
  };

  // Works on all mobile devices
  document.addEventListener("click", handler, { passive: false });
  document.addEventListener("touchstart", handler, { passive: false });
});



document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.template-product .product-gallery');
  const zoomBtn = document.querySelector('.product-gallery__zoom-button');

  if (!gallery || !zoomBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      zoomBtn.style.display = entry.isIntersecting ? '' : 'none';
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '-100px 0px -100px 0px'
    }
  );

  observer.observe(gallery);
});